import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-bar-grafik',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg viewBox="0 0 200 120" preserveAspectRatio="xMidYMid meet" class="bar-svg">
      @for (bar of barlar(); track bar.idx) {
        <rect
          [attr.x]="bar.x" [attr.y]="bar.y"
          [attr.width]="bar.genislik" [attr.height]="bar.yukseklik"
          [attr.fill]="bar.renk" rx="2" class="bar-rect"
        />
        <text
          [attr.x]="bar.x + bar.genislik / 2" [attr.y]="112"
          text-anchor="middle" font-size="9" fill="currentColor" opacity="0.6">
          {{ bar.etiket }}
        </text>
        <text
          [attr.x]="bar.x + bar.genislik / 2" [attr.y]="bar.y - 3"
          text-anchor="middle" font-size="8" fill="currentColor" opacity="0.5">
          {{ bar.deger }}
        </text>
      }
    </svg>
  `,
  styles: [`
    :host { display: block; line-height: 0; }
    .bar-svg { width: 100%; height: auto; }
    .bar-rect { transition: y 0.4s cubic-bezier(0.4,0,0.2,1), height 0.4s cubic-bezier(0.4,0,0.2,1); }
  `],
})
export class BarGrafikComponent {
  veriler = input<{ etiket: string; deger: number; renk?: string }[]>([]);

  private readonly PAD = 10;
  private readonly GRAFIK_UST = 15;
  private readonly GRAFIK_ALT = 100;
  private readonly VARSAYILAN_RENK = '#1890ff';

  barlar = computed(() => {
    const v = this.veriler();
    if (!v?.length) return [];
    const maxDeger = Math.max(...v.map(d => d.deger), 1);
    const toplamGen = 200 - this.PAD * 2;
    const bosluk = Math.max(2, toplamGen * 0.15 / v.length);
    const barGen = (toplamGen - bosluk * (v.length - 1)) / v.length;
    const grafikYukseklik = this.GRAFIK_ALT - this.GRAFIK_UST;

    return v.map((d, idx) => {
      const h = (d.deger / maxDeger) * grafikYukseklik;
      return {
        idx,
        x: this.PAD + idx * (barGen + bosluk),
        y: this.GRAFIK_ALT - h,
        genislik: Math.max(barGen, 4),
        yukseklik: Math.max(h, 1),
        renk: d.renk || this.VARSAYILAN_RENK,
        etiket: d.etiket.length > 5 ? d.etiket.slice(0, 4) + '…' : d.etiket,
        deger: d.deger,
      };
    });
  });
}
